import React, { useCallback } from 'react'
import { makeStyles, styled } from '@material-ui/styles'
import Text from 'core/elements/Text'
import ModalForm from 'core/elements/modal/ModalForm'
import useParams from 'core/hooks/useParams'
import Info from 'core/components/validatedForm/Info'
import Theme from 'core/themes/model'
import FontAwesomeIcon from 'core/components/FontAwesomeIcon'
import DropdownField from 'core/components/validatedForm/DropdownField'
import useUpdateAction from 'core/hooks/useUpdateAction'
import { setVolumeState } from './actions'
import VolumeStatusPickList from './VolumeStatusPickList'

const Container = styled('div')({
  gap: 16,
  display: 'grid',
})

const useStyles = makeStyles<Theme>((theme: Theme) => ({
  warning: {
    display: 'grid',
    gap: 8,
  },
  icon: {
    marginRight: 8,
  },
}))

export default function SetStateVolumeDialog({ rows: [volume], onClose, reloadVolumes }) {
  const classes = useStyles()
  const { params, getParamsUpdater } = useParams({
    newState: '',
  })
  const { update, updating, error, reset } = useUpdateAction(setVolumeState)

  const handleSubmit = useCallback(async () => {
    const body = {
      'os-reset_status': {
        status: params.newState,
      },
    }
    const { success } = await update({
      id: volume?.id,
      body,
    })
    if (success) {
      reloadVolumes?.()
      handleClose(true)
    }
  }, [volume, params])

  const handleClose = (success?: boolean) => {
    reset()
    onClose(success)
  }

  return (
    <ModalForm
      title="Set Volume State"
      onSubmit={handleSubmit}
      onClose={onClose}
      submitting={updating}
      error={error}
      submitTitle="Set State"
      panel="dialog"
      maxWidth={600}
      disableSubmit={!params.newState}
      open
    >
      <Container>
        <Info error>
          <div className={classes.warning}>
            <Text variant="body2">
              <FontAwesomeIcon className={classes.icon}>triangle-exclamation</FontAwesomeIcon>
              <b>WARNING</b>
            </Text>
            <Text variant="body2">
              This action forcefully overrides the current volume state in the database. It should
              only be used as a recovery step.
            </Text>
          </div>
        </Info>
        <Text variant="body2">Choose the state you want to set for this volume.</Text>
        <DropdownField
          id="newState"
          label="Volume State"
          value={params.newState}
          onChange={getParamsUpdater('newState')}
          currentStatus={volume?.status}
          required
          DropdownComponent={VolumeStatusPickList}
          volume={volume}
        />
        <br />
      </Container>
    </ModalForm>
  )
}
